/**
 * @file ハンバーガーメニューの開閉
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname Collapsed
 * @classdesc 折りたたみ
 */
export default class Collapsed {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Collapsed.constructor')
		this._$e = $e
		
		// プレビュー時は無効
		if(this._$e.closest('html.preview').length > 0) return;

		this._$target = $(`#${$e.attr('aria-controls')}`)
		$e.on('click', () => this.onClick())
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof Collapsed
	 * @return {undefined}
	 */
	onClick() {
		console.log('Collapsed.onClick')
		// プレビュー時は無効
		if(this._$e.closest('html.preview').length > 0) return;

		this._$target.toggleClass('active')
		$('body').toggleClass('active')
		$('#mask').toggleClass('active')
	}
}
